import { requestFuelApiHost } from './requestFuelApiHost';
import { requestToken } from './requestToken';

export async function fetchSmartCaptureForms(params) {
	let url = `/fuelapi/internal/v2/CloudPagesJourneyBuilderEvent/smartcapture-forms?dataTargetTypeId=1&isUsedInInteraction=false&$page=${params.page}&$pageSize=${params.pageSize}`;

	const fuelApiRestHost = await requestFuelApiHost();
	const token = await requestToken();

	if (params.channelTypeId) {
		url += `&channelTypeId=${params.channelTypeId}`;
	}
	if (params.search && params.search !== '') {
		url += `&name=contains(${params.search})`;
	}

	const response = await fetch(url, {
		headers: {
			'Content-Type': 'application/json',
			'authorization': `Bearer ${token}`,
			'x-fuel-api-rest-host': fuelApiRestHost
		}
	});

	if (!response.ok) {
		throw new Error(`HTTP error! status: ${response.status}`);
	}

	const data = await response.json();
	return data;
}